import { Header } from './Header';
import { usePlants } from '../../hooks/usePlants';

/**
 * Header wrapper that provides plant count from usePlants hook.
 * This is separated to avoid calling usePlants in the router layout.
 */
export function HeaderWithPlantCount() {
  const { plantCount } = usePlants();

  return <Header plantCount={plantCount} />;
}
